<template>
  <div class="group container">
    <div v-if="showTestButton">
      <EntryTest :step="2" />
    </div>
    <entry-index :step="2"></entry-index>
    <h3>受講者情報入力</h3>
    <div class="alert alert-info">
      <div>1回のお申し込みで{{entrantMax}}名様まで入力できます。</div>
      <div>11名以上でお申し込みの場合は，複数回に分けて入力してください。</div>
      <div>ご入力いただいた受講者に個別のチケットを発行いたします。</div>
    </div>
    <validation-observer v-slot="{ handleSubmit, validated, invalid }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div v-for="(item, index) in $store.state.entry.entrant" :key="item.key">
          <entry-entrant :index="index" :item="item"/>
        </div>
        <div class="container">
          <button type="button" class="btn btn-lg btn-link" id="btnAddEntrant" :disabled="$store.state.entry.entrant.length >= entrantMax" @click="onAddEntrant">
            <span style="font-size:1.4em"><i class="fas fa-plus"></i> 受講者を追加</span>
          </button>
        </div>
        <!-- ナビゲーションボタン -->
        <div class="form-row">
          <div class="col-6">
            <button type="button" class="btn btn-lg btn-default btn-block prev_button" @click="onClickPrev">
              <i class="fas fa-chevron-circle-left"></i>　送付先情報入力へ
            </button>
          </div>
          <div class="col-6">
            <button type="submit" class="btn btn-lg btn-secondary btn-block next_button">
              お支払い方法選択へ　<i class="fas fa-chevron-circle-right"></i>
            </button>
            <div class="text-danger" v-if="validated && invalid">入力項目をご確認ください。</div>
            <validation-provider rules="entrant-count" v-slot="{ errors }">
              <input type="hidden" v-model="entrantCount">
              <div class="text-danger">{{ errors[0] }}</div>
            </validation-provider>
          </div>
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import EntryIndex from "@/components/EntryIndex.vue"
import EntryTest from "@/components/EntryTest.vue"
import EntryEntrant from '@/components/EntryEntrant'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'EntryStep2',
  components: {
    ValidationObserver,
    ValidationProvider,
    EntryIndex,
    EntryEntrant,
    EntryTest
  },
  data() {
    return {
      entrantKey: 1,
      entrantMax: 10
    }
  },
  computed: {
    showTestButton() {
      return this.$store.state.showTestButton
    },
    entrantCount() {
      return this.$store.getters["entry/entrantCount"]
    }
  },
  mounted() {
    document.getElementById('html').scrollTop = 0
  },
  methods: {
    onAddEntrant: function() {
      window.console.log('append entrant key', this.entrantKey)
      this.$store.dispatch('entry/appendEntrant', {
        key: this.entrantKey,
        nameFamily: '',
        nameFirst: '',
        kanaFamily: '',
        kanaFirst: '',
        subject: '',
        grade: '',
        division: '',
        part: '',
        course: '',
        waiting: 0
      })
      this.entrantKey++
    },
    onClickPrev() {
      this.$router.back()
    },
    onSubmit() {
      this.$router.push('step3')
    }
  }
}
</script>
